import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M11.707 7.73a1 1 0 1 1-1.414-1.414 1 1 0 0 1 1.414 1.414Zm-7.414 0a1 1 0 1 0 1.414-1.414A1 1 0 0 0 4.293 7.73Zm4.414 0a1 1 0 1 0-1.414-1.414A1 1 0 0 0 8.707 7.73Z"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.395 10.973 0 15.977l5.696-2.249c.73.192 1.503.295 2.304.295 4.418 0 8-3.134 8-7s-3.582-7-8-7-8 3.134-8 7c0 1.465.515 2.826 1.395 3.95Zm1.611 1.667.587-2.104-.623-.796C2.342 8.938 2 8.005 2 7.023c0-2.52 2.427-5 6-5s6 2.48 6 5c0 2.519-2.427 5-6 5-.63 0-1.232-.081-1.796-.23l-.633-.165-2.565 1.012Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconActionMessageLine16 = createIcon(IconComponent);